import { SideNavItem } from 'app/models/SideNavItem';
import { AppOverviewSectionComponent } from './sections/app-overview-section/app-overview-section.component';
import { AppRiskOverviewSectionComponent } from './sections/app-risk-overview-section/app-risk-overview-section.component';
import { AppDetailsSectionComponent } from './sections/app-details-section/app-details-section.component';
import { AppDeveloperOverviewSectionComponent } from './sections/app-developer-overview-section/app-developer-overview-section.component';
import { AppRankingsSectionComponent } from './sections/app-rankings-section/app-rankings-section.component';
import { AppPermissionRiskSectionComponent } from './sections/app-permission-risk-section/app-permission-risk-section.component';
import { AppCoppaViolationRiskSectionComponent } from './sections/app-coppa-violation-risk-section/app-coppa-violation-risk-section.component';
import { AppBrandSafetyRiskSectionComponent } from './sections/app-brand-safety-risk-section/app-brand-safety-risk-section.component';
import { AppTrafficTrendsSectionComponent } from './sections/app-traffic-trends-section/app-traffic-trends-section.component';
import { AppAuthorizedSellerSectionComponent } from './sections/app-authorized-seller-section/app-authorized-seller-section.component';
import { AppIvtSectionComponent } from './sections/app-ivt-section/app-ivt-section.component';
import { AppViewabilitySectionComponent } from './sections/app-viewability-section/app-viewability-section.component';
import { AppAdSpendSectionComponent } from './sections/app-ad-spend-section/app-ad-spend-section.component';
import { AppInventorySectionComponent } from './sections/app-inventory-section/app-inventory-section.component';
import { AppCtrSectionComponent } from './sections/app-ctr-section/app-ctr-section.component';
import { AppDeveloperAppsSectionComponent } from './sections/app-developer-apps-section/app-developer-apps-section.component';
import { AppMfaSectionComponent } from './sections/app-mfa-section/app-mfa-section.component';
import { AppSdkDetailsSectionComponent } from './sections/app-sdk-details-section/app-sdk-details-section.component';
import { AppEngagementMetricsSectionComponent } from './sections/app-engagement-metrics-section/app-engagement-metrics-section.component';

export const appDetailsNavItems: Array<SideNavItem> = [
  {
    key: 'overview',
    iconURL: '/assets/images/sidenav-icon-overview.svg',
    label: 'Overview',
    widgetComponent: AppOverviewSectionComponent
  },
  {
    key: 'app-risk-overview',
    iconURL: '/assets/images/sidenav-icon-risk-overview.svg',
    label: 'Risk Overview',
    widgetComponent: AppRiskOverviewSectionComponent
  },
  {
    key: 'app-engagement-metrics',
    iconURL: '/assets/images/icon-engagement-metrics.svg',
    label: 'Audience Engagement',
    beta: true,
    widgetComponent: AppEngagementMetricsSectionComponent,
    showIf: {
      hasPermission: 'mrtAppEngagement'
    }
  },
  {
    key: 'app-details',
    iconURL: '/assets/images/sidenav-icon-app-details.svg',
    label: 'App Details',
    widgetComponent: AppDetailsSectionComponent
  },
  {
    key: 'app-publisher',
    iconURL: '/assets/images/sidenav-icon-developer-overview.svg',
    label: 'Developer Overview',
    widgetComponent: AppDeveloperOverviewSectionComponent
  },
  {
    key: 'app-sov',
    iconURL: '/assets/images/sidenav-icon-authorized-seller.svg',
    label: 'Authorized Seller (app-ads.txt)',
    beta: true,
    widgetComponent: AppAuthorizedSellerSectionComponent,
    showIf: {
      hasData: {
        notEmpty: 'sellerDistribution/sellers'
      }
    }
  },
  {
    key: 'app-sdk-details',
    iconURL: '/assets/images/sidenav-icon-sdks.svg',
    label: 'SDK Details',
    widgetComponent: AppSdkDetailsSectionComponent,
    showIf: {
      hasData: {
        notEmpty: 'sdkDetails'
      },
      hasPermission: 'mrtAppSdkDetails'
    }
  },
  {
    key: 'app-country-rankings',
    iconURL: '/assets/images/sidenav-icon-rankings.svg',
    label: 'Rankings',
    widgetComponent: AppRankingsSectionComponent,
    showIf: {
      hasData: {
        notNull: 'rankingsByCountry',
        notEmpty: ['rankingsByCountry/reach', 'rankingsByCountry/marketShare']
      }
    }
  },
  {
    key: 'app-permission-risk',
    iconURL: '/assets/images/icon-permissions.svg',
    label: 'App Permission Risk',
    beta: true,
    widgetComponent: AppPermissionRiskSectionComponent,
    showIf: {
      hasData: {
        notNull: 'permissions'
      },
      isFilter: {
        os: 'android'
      }
    }
  },
  {
    key: 'app-coppa-permission-risk',
    iconURL: '/assets/images/icon-24-brand-safety.svg',
    label: 'COPPA Violation Risk',
    widgetComponent: AppCoppaViolationRiskSectionComponent,
    showIf: {
      hasData: {
        notNull: 'coppaPermissions'
      }
    }
  },
  {
    key: 'app-content-brand-safety',
    iconURL: '/assets/images/sidenav-icon-brand-safety.svg',
    label: 'Brand Safety Risk',
    beta: true,
    widgetComponent: AppBrandSafetyRiskSectionComponent
  },
  {
    key: 'app-traffic-overlap',
    iconURL: '/assets/images/sidenav-icon-traffic-overlap.svg',
    label: 'Traffic Trends',
    beta: true,
    widgetComponent: AppTrafficTrendsSectionComponent
  },
  {
    key: 'app-mfa',
    iconURL: '/assets/images/icon-mfa.svg',
    label: 'Made For Advertising',
    beta: true,
    widgetComponent: AppMfaSectionComponent
  },
  {
    key: 'app-ivt',
    iconURL: '/assets/images/sidenav-icon-invalid-traffic.svg',
    label: 'Invalid Traffic',
    widgetComponent: AppIvtSectionComponent,
    showIf: {
      hasData: {
        notNull: 'ivtDistribution/givtSivtRate',
        notNA: 'ivtDistribution/givtSivtRate'
      }
    },
    permissions: {
      oneOf: ['follower', 'enterprise']
    }
  },
  {
    key: 'app-viewability',
    iconURL: '/assets/images/icon-viewability.svg',
    label: 'Viewability',
    widgetComponent: AppViewabilitySectionComponent,
    showIf: {
      hasData: {
        notNA: 'viewabilityDistribution/nonGivtSivtViewability',
        notEmpty: 'viewabilityDistribution/byMonth'
      }
    }
  },
  {
    key: 'app-ad-spend',
    iconURL: '/assets/images/icon-24-incentivized-2.svg',
    label: 'Est. Ad Spend',
    beta: true,
    widgetComponent: AppAdSpendSectionComponent,
    showIf: {
      hasData: {
        notEmpty: 'adSpend/byMonth'
      },
      hasPermission: 'mrtAppAdSpend'
    },
    permissions: {
      mustHave: ['mrtAppAdSpend']
    }
  },
  {
    key: 'app-inventory',
    iconURL: '/assets/images/sidenav-icon-inventory.svg',
    label: 'Inventory',
    widgetComponent: AppInventorySectionComponent,
    showIf: {
      hasData: {
        notEmpty: [
          'inventoryDistribution/regions',
          'inventoryDistribution/countries',
          'inventoryDistribution/adSizes',
          'inventoryDistribution/devices',
          'inventoryDistribution/dmas',
          'inventoryDistribution/states'
        ]
      }
    }
  },
  {
    key: 'app-ctr',
    iconURL: '/assets/images/icon-click-through.svg',
    label: 'Click Through',
    widgetComponent: AppCtrSectionComponent,
    showIf: {
      hasData: {
        notNull: 'ctrDistribution',
        notNA: 'ctrDistribution/ctr'
      }
    }
  },
  {
    key: 'app-developer-apps',
    iconURL: '/assets/images/grid.svg',
    label: 'More Apps',
    widgetComponent: AppDeveloperAppsSectionComponent,
    showIf: {
      hasData: {
        notNull: 'publisherOverview/name',
        gtOne: 'publisherOverview/totalApps'
      }
    },
    permissions: {
      mustHave: ['enterprise']
    }
  }
];
